var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgShuffle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 3.20703C10.2518 3.20703 9.91602 2.87124 9.91602 2.45703C9.91602 2.04282 10.2518 1.70703 10.666 1.70703H13.9993C14.4136 1.70703 14.7493 2.04282 14.7493 2.45703V5.79036C14.7493 6.20458 14.4136 6.54036 13.9993 6.54036C13.5851 6.54036 13.2493 6.20458 13.2493 5.79036V4.26769L3.19635 14.3207C2.90345 14.6136 2.42858 14.6136 2.13569 14.3207C1.84279 14.0278 1.84279 13.5529 2.13569 13.26L12.1887 3.20703H10.666ZM2.13569 2.59337C2.42858 2.30047 2.90345 2.30047 3.19635 2.59337L6.52968 5.9267C6.82257 6.21959 6.82257 6.69447 6.52968 6.98736C6.23679 7.28025 5.76191 7.28025 5.46902 6.98736L2.13569 3.65403C1.84279 3.36113 1.84279 2.88626 2.13569 2.59337ZM9.46902 9.9267C9.76191 9.63381 10.2368 9.63381 10.5297 9.9267L13.2493 12.6464V11.1237C13.2493 10.7095 13.5851 10.3737 13.9993 10.3737C14.4136 10.3737 14.7493 10.7095 14.7493 11.1237V14.457C14.7493 14.8712 14.4136 15.207 13.9993 15.207H10.666C10.2518 15.207 9.91602 14.8712 9.91602 14.457C9.91602 14.0428 10.2518 13.707 10.666 13.707H12.1887L9.46902 10.9874C9.17613 10.6945 9.17613 10.2196 9.46902 9.9267Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShuffle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shuffle.dee07b3f.svg";
export { ForwardRef as ReactComponent };